export default {
  message: {
    title: '',
    preferVisitRead: '',
    preferVisitListten: '',
    preferVisitComplete: 'Completa',
    preferVisitShort: 'Curta',
    preferVisitSignoguia: 'Signoguia',
    titleVisitType: 'Visites guiades',
    titleMenu: 'Menú',
    moreInfo:'Saber-ne més?',
    moreInfoNo: 'No',
    moreInfoYes:'Sí',
    downloadAudio: '(Descàrrega d\'àudios)',
    download: 'Descàrrega dels arxius',
    downloadVideo: '(Descàrrega de videos)',
    downloadSignoguia: 'Descàrrega dels arxius de video',
    errorDownload: 'Hi ha hagut un error en la descàrrega. Torna a intentar-ho',
    cancelDownload: 'Has cancel·lat la descàrrega.',
    retry: 'Reintentar',
    noConnection: 'No tens conexió a internet',
    titleMap: 'CHOISISSEZ UN NUMÉRO',
    map: 'mapa_fra.png',

    initDownload: 'Merci de patienter pendant le chargement des fichiers audio',
    endDownload: 'Fichiers télechargés. Bonne visite! ',



    menuItems: [
        {
            img: '1a.jpg',
            imageMenu: '',
            title: 'APPUYEZ SUR PLAY',
            author: '',
            description: '',
            audio: '1.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '1a.jpg',
                    second: '0'
                },
                {
                    img: '1b.jpg',
                    second: '49'
                },
            ],
        },
        {
            img: '2.jpg',
            imageMenu: '',
            title: '2. PURIFICATION',
            author: '',
            description: '',
            audio: '2.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '3.jpg',
            imageMenu: '',
            title: '3. CONDAMNATION',
            author: '',
            description: '',
            audio: '3.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '4.jpg',
            imageMenu: '',
            title: '4. CHUTE',
            author: '',
            description: '',
            audio: '4.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '5.jpg',
            imageMenu: '',
            title: '5. MARC',
            author: '',
            description: '',
            audio: '5.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '6.jpg',
            imageMenu: '',
            title: '6. LUC',
            author: '',
            description: '',
            audio: '6.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '7.jpg',
            imageMenu: '',
            title: '7. THOMAS',
            author: '',
            description: '',
            audio: '7.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '8a.jpg',
            imageMenu: '',
            title: '8. JACQUES LE JUSTE',
            author: '',
            description: '',
            audio: '8.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '8a.jpg',
                    second: '0'
                },
                {
                    img: '8b.jpg',
                    second: '66'
                },
            ],
        },
        {
            img: '9.jpg',
            imageMenu: '',
            title: '9. JACQUES LE MAJEUR',
            author: '',
            description: '',
            audio: '9.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '10a.jpg',
            imageMenu: '',
            title: '10. PHILIPPE',
            author: '',
            description: '',
            audio: '10.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '10a.jpg',
                    second: '0'
                },
                {
                    img: '10b.jpg',
                    second: '58'
                },
            ],
        },
        {
            img: '11.jpg',
            imageMenu: '',
            title: '11. ANDRÉ',
            author: '',
            description: '',
            audio: '11.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '12.jpg',
            imageMenu: '',
            title: '12. BARTHÉLEMY',
            author: '',
            description: '',
            audio: '12.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '13.jpg',
            imageMenu: '',
            title: '13. PIERRE ET PAUL',
            author: '',
            description: '',
            audio: '13.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '14a.jpg',
            imageMenu: '',
            title: '14. SIMON ET THADDÉE',
            author: '',
            description: '',
            audio: '14.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '14a.jpg',
                    second: '0'
                },
                {
                    img: '14b.jpg',
                    second: '17'
                },
                {
                    img: '14c.jpg',
                    second: '33'
                },
            ],
        },
        {
            img: '15.jpg',
            imageMenu: '',
            title: '15. JEAN',
            author: '',
            description: '',
            audio: '15.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '16.jpg',
            imageMenu: '',
            title: '16. MATTHIEU',
            author: '',
            description: '',
            audio: '16.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '17.jpg',
            imageMenu: '',
            title: '17. PÉCHÉ',
            author: '',
            description: '',
            audio: '17.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '18.jpg',
            imageMenu: '',
            title: '18. MORT',
            author: '',
            description: '',
            audio: '18.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '19.jpg',
            imageMenu: '',
            title: '19. GUERRE',
            author: '',
            description: '',
            audio: '19.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '20.jpg',
            imageMenu: '',
            title: '20. PARADIS REFERMÉ',
            author: '',
            description: '',
            audio: '20.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '21a.jpg',
            imageMenu: '',
            title: '21. CRUCIFIXION',
            author: '',
            description: '',
            audio: '21.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '21a.jpg',
                    second: '0'
                },
                {
                    img: '21b.jpg',
                    second: '126'
                },
            ],
        },
        {
            img: '22.jpg',
            imageMenu: '',
            title: '22. MISE AU TOMBEAU',
            author: '',
            description: '',
            audio: '22.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '23.jpg',
            imageMenu: '',
            title: '23. ASCENSION',
            author: '',
            description: '',
            audio: '23.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '24.jpg',
            imageMenu: '',
            title: '24. MARC',
            author: '',
            description: '',
            audio: '24.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '25.jpg',
            imageMenu: '',
            title: '25. LUC',
            author: '',
            description: '',
            audio: '25.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '26.jpg',
            imageMenu: '',
            title: '26. JEAN',
            author: '',
            description: '',
            audio: '26.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '27.jpg',
            imageMenu: '',
            title: '27. MATTHIEU',
            author: '',
            description: '',
            audio: '27.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '28.jpg',
            imageMenu: '',
            title: '28. ESPACE SERT',
            author: '',
            description: '',
            audio: '28.mp3',
            video: '',
            visitType: '{all}',
        },
        {
            img: '29a.jpg',
            imageMenu: '',
            title: '29. PEINTURES',
            author: '',
            description: '',
            audio: '29.mp3',
            video: '',
            visitType: '{all}',
            imagesAudio: [
                {
                    img: '29a.jpg',
                    second: '0'
                },
                {
                    img: '29b.jpg',
                    second: '64'
                },
            ],
        },
        {
            img: '30.jpg',
            imageMenu: '',
            title: '30. MAQUETTE',
            author: '',
            description: '',
            audio: '30.mp3',
            video: '',
            visitType: '{all}',
        },

        {
            img: '31.jpg',
            imageMenu: 'thumb_2.png',
            title: 'Credits',
            author: '',
            description: 'Script et production : Trama Media.<br><br>Remerciements : Diocèse de Vic.<br><br>Photographies : Pepo Segura, Guillem Mercadal, MNAC, CRBMC.<br><br>Citations : Josep Torras i Bages, <i>La ciència del patir.</i> Foment de la Pietat Catalana, Barcelona, 1927.<br><br>Trama Media s\'est efforcé d\'obtenir les autorisations nécessaires pour touts les contenus reproduits dans ce guide. Cependant, si vous souhaitez faire une réclamation relative aux questions de propriété intellectuelle, n\'hésitez pas à nous contacter.<br><br>© des photographies et textes cités : les auteurs.<br>© du reste : Trama Media.<br><br>',
            audio: '',
            visitType: '{all}',
            moreInfoItem: '',
            isCredits: true,

        }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/data/i18n/français.js